import { Button } from '@material-ui/core';
import { useEffect } from 'react';
import en from '../../../../lang/en-us';
import SuccessScreen from '../SuccessScreen';
const { dashboard } = en;

export default function ConsolidationFoliosSuccess(props: any) {
    const { reqId } = props.location.state || {};

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
        }
    }, []);
    return (
        <div className="curved-bg">
            <SuccessScreen
                heading={dashboard.ConsolidationFolios.Success.back}
                backLink="nct"
                info1={dashboard.ConsolidationFolios.Success.subHeadingInfo1}
                infospan1="“AXIS Mutual Fund”"
                info2={dashboard.ConsolidationFolios.Success.subHeadingInfo2}
                infospan2={`${reqId}`}
                info3={dashboard.ConsolidationFolios.Success.subHeadingInfo3}
                list={[]}
                handleClick={() => props.history.push('/portal/track')}
                backNavigation={() => props.history.goBack()}
            />
        </div>
    );
}
